import React from "react";
import FounderImg from "../../Assessts/Images/AboutUs/Founder/Founder.png";
import Theory from "../../Assessts/Images/AboutUs/Founder/Theory.jpg";
import Holist from "../../Assessts/Images/AboutUs/Founder/Holistic.jpg";
const Founder = () => {
    const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };
  return (
    <>
      <section className="founder-section">
        <div className="founder-buttons">
          <button onClick={() => scrollToSection("founder-message")}>Message from the Founder</button>
          <button onClick={() => scrollToSection("theory-of-change")}>Theory of Change</button>
          <button onClick={() => scrollToSection("holistic-approach")}>Our Holistic Approach</button>
        </div>

        <div className="founder-profile">
          <img src={FounderImg} alt="Dr. Ratnam Chitturi" className="founder-image" />
          <h2>Dr. Ratnam Chitturi</h2>
          <p>Founder &amp; Mentor</p>
        </div>
      </section>

      <section className="founder-message" id="founder-message">
        <div className="founder-container">
          <h2>Message from the Founder</h2>

          <p>
            Dr. Ratnam Chitturi, a visionary leader in education and social
            entrepreneurship, is the Founder, Chief Mentor, and Director of the
            North South Foundation (North South), a nonprofit organization
            established in 1989. NorthSouth's dual mission is
            transformative: to empower underprivileged students in India through
            scholarships and to nurture academic excellence among Indian American
            youth in the U.S.
          </p>

          <p>
            To date, over 40,000 scholarships have been awarded in India, and
            more than 50,000 children in the U.S. have benefited from its
            programs, which span STEM, communication, universal values, and
            leadership. Through his innovative leadership, Dr. Chitturi has built
            platforms where young minds can excel, producing champions in
            prestigious competitions like the Scripps National Spelling Bee and
            National Geographic Bee, and paving their way to top U.S.
            universities.
          </p>

          <p>
            Beyond NorthSouth, Dr. Chitturi's initiatives include the{" "}
            Svayamkrishi Endowment, promoting sustainable rural
            development in India, and the Pearls of India Foundation, which
            educates the diaspora’s younger generation about India’s heritage
            through storytelling and videos. His research explores India’s
            civilizational legacy and Vedic traditions, offering critical
            analyses of Western Indology through an Indic lens, thus contributing
            to the global discourse on cultural narratives.
          </p>
        </div>
      </section>

      <section className="founder-message dflex alignitems" id="theory-of-change">
        <img src={Theory} alt="Theory of Change" className="w-50" />
        <div className="founder-container">
          <h2>Theory of Change</h2>
          <p>
            Theory of Change North South Foundation believes that when meritorious students from economically disadvantaged backgrounds receive comprehensive support through Scholarships, Mentorship, Skill Development, Mental Health & Wellbeing, and Seva (Community Service), they are more likely to complete higher education, become employable, develop leadership qualities, and contribute positively to society. This holistic approach creates a pathway from education to empowerment, enabling scholars to transform their own lives, support their families, serve their communities, and become responsible nation builders.
          </p>
          <p> Scholarships → Mentorship → Skills → Wellbeing → Service → Leadership → Nation Building. </p>
        </div>
      </section>

      <section className="founder-message dflex alignitems" id="holistic-approach" >
        <div className="founder-container">
          <h2>Our Holistic Approach​</h2>
          <p> Theory of Change North South Foundation believes that when meritorious students
            from economically disadvantaged backgrounds receive comprehensive support through
            Scholarships, Mentorship, Skill Development, Mental Health & Wellbeing, and Seva
            (Community Service), they are more likely to complete higher education, become
            employable, develop leadership qualities, and contribute positively to society. This
            holistic approach creates a pathway from education to empowerment, enabling scholars
            to transform their own lives, support their families, serve their communities, and
            become responsible nation builders. </p>
          <p> Scholarships → Mentorship → Skills → Wellbeing → Service → Leadership → Nation Building.​ </p>
        </div>
        <img src={Holist} alt="Our Holistic Approach" className=" w-50" />
      </section>
    </>
  )
}
export default Founder